// import { Link } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import PropTypes from 'prop-types';
import React from 'react';
import { render } from 'storyblok-rich-text-react-renderer';

import ResImg from 'components/resImg';
import ResVideo from 'components/resVideo';

import IconArrow from '../icons/icon-arrow';
import ReadMore from '../read-more/read-more';

const MediaCard = ({ blok, aspectRatioClass, containerClass, titleClass, captionClass }) => {
  const { title, text, tag, link, blurb } = blok;
  const renderedText = render(text);
  const hasVideo =
    blok.mobile_video?.filename !== undefined &&
    blok.video?.filename !== '' &&
    blok.video?.filename !== null;
  const aspectRatio = {
    desktop: blok?.aspect_ratio,
    mobile: blok?.aspect_ratio_mobile,
  };

  if (link.cached_url?.startsWith('/en-nz')) {
    link.cached_url = link.cached_url.replace('/en-nz', '');
  }

  return (
    <figure
      className={`relative flex flex-col ${containerClass} ${
        !blurb && !renderedText ? 'h-full' : ''
      }`}
    >
      <div className={`relative overflow-hidden object-cover ${aspectRatioClass}`}>
        {hasVideo ? (
          <ResVideo
            mobileVideo={blok.mobile_video}
            desktopVideo={blok.video}
            mobilePoster={blok.mobile_image}
            desktopPoster={blok.image}
            aspectRatio={aspectRatio}
          />
        ) : (
          <ResImg
            mobile={blok.mobile_image}
            desktop={blok.image}
            aspectRatio={aspectRatio}
            critical
          />
        )}
        {link.cached_url !== '' && (
          <AniLink
            to={link.cached_url === 'index' ? '/' : link.cached_url}
            className="absolute inset-0"
            direction="up"
            bg="#000000"
            duration={1}
            cover
          >
            <span className="sr-only">{title}</span>
          </AniLink>
        )}
      </div>
      <figcaption
        className={`space-y-4 pb-2 pt-4 xl:space-y-8 xl:pb-4 xl:pt-8 ${captionClass} ${
          !blurb && !renderedText ? 'relative' : ''
        }`}
      >
        <div className="flex items-center justify-between">
          <div className="flex gap-6 text-xs !leading-[1.35] tracking-[0.015rem] lg:text-base xl:text-[1.375rem]">
            <h4
              className={`font-semibold ${
                tag || renderedText ? 'font-sans' : 'font-heading lg:text-xl xl:text-[1.375rem]'
              } ${titleClass}`}
            >
              {title}
            </h4>
            {tag && <span className="hidden lg:block">{tag}</span>}
          </div>
          {!blurb && (
            <AniLink
              to={link.cached_url === 'index' ? '/' : link.cached_url}
              className='group flex items-center after:absolute after:inset-0 after:content-[""]'
              direction="up"
              bg="#000000"
              duration={1}
              cover
            >
              <span className="sr-only">{title}</span>
              <span className="w-4 translate-x-0 transition-all duration-200 group-hover:translate-x-[0.15rem] lg:w-auto">
                <IconArrow className="w-full lg:w-auto" />
              </span>
            </AniLink>
          )}
        </div>
        {renderedText && (
          <div className="text-sm lg:text-[1.09375rem] lg:!leading-[1.12] xl:text-2xl">
            {renderedText && blurb ? (
              <ReadMore excerpt={blurb}>
                <div className="prose text-sm lg:text-[1.09375rem] lg:!leading-[1.12] xl:text-2xl">
                  {renderedText}
                </div>
              </ReadMore>
            ) : (
              <div className="prose text-sm lg:text-[1.09375rem] lg:!leading-[1.12] xl:text-2xl">
                {renderedText}
              </div>
            )}
          </div>
        )}
      </figcaption>
    </figure>
  );
};

MediaCard.propTypes = {
  blok: PropTypes.object.isRequired,
  aspectRatioClass: PropTypes.string,
  containerClass: PropTypes.string,
  titleClass: PropTypes.string,
  captionClass: PropTypes.string,
};

MediaCard.defaultProps = {
  aspectRatioClass: '',
  containerClass: '',
  titleClass: '',
  captionClass: '',
};
export default MediaCard;
